import React, { useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { GetUnixDate } from "../../components/GetUnixDate/GetUnixDate";
import { InstallationsReport } from "../../services/services";
import { CampaignonvertUnixToGregorian } from "../../components/ConvertUnixToGregorian/ConvertUnixToGregorian";
import ReportInstall from "./ReportInstall";

export default function Charts() {
  return (
    <div className="custom-container">
      <h4 style={{ margin: "10px 30px 0px 0px" }}>گزارش‌ها</h4>
      <div className="col-4 ">
        <ReportInstall />
      </div>
    </div>
  );
}
